import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
  articleAuthor?: string;
  articleSection?: string;
  children?: React.ReactNode;
}

export default function SEOHead({
  title,
  description,
  keywords = '吃瓜爆料,热门吃瓜,明星八卦,网红黑料,每日大赛,吃瓜事件,免费在线,最新爆料,吃瓜社区,吃瓜爆料网',
  canonical = 'http://94exue.cn',
  ogType = 'website',
  ogImage,
  articlePublishedTime,
  articleModifiedTime,
  articleAuthor,
  articleSection,
  children,
}: SEOHeadProps) {
  useEffect(() => {
    document.title = title;

    const updateMeta = (name: string, content: string, isProperty = false) => {
      const selector = isProperty ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement | null;
      if (!meta) {
        meta = document.createElement('meta');
        if (isProperty) {
          meta.setAttribute('property', name);
        } else {
          meta.setAttribute('name', name);
        }
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    updateMeta('description', description);
    updateMeta('keywords', keywords);

    updateMeta('og:title', title, true);
    updateMeta('og:description', description, true);
    updateMeta('og:type', ogType, true);
    updateMeta('og:url', canonical, true);
    updateMeta('og:site_name', '吃瓜爆料', true);
    if (ogImage) {
      updateMeta('og:image', ogImage, true);
    }

    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:title', title);
    updateMeta('twitter:description', description);

    if (articlePublishedTime) {
      updateMeta('article:published_time', articlePublishedTime, true);
    }
    if (articleModifiedTime) {
      updateMeta('article:modified_time', articleModifiedTime, true);
    }
    if (articleAuthor) {
      updateMeta('article:author', articleAuthor, true);
    }
    if (articleSection) {
      updateMeta('article:section', articleSection, true);
    }

    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = canonical;
  }, [title, description, keywords, canonical, ogType, ogImage, articlePublishedTime, articleModifiedTime, articleAuthor, articleSection]);

  return <>{children}</>;
}
